import { MdOutlineClose } from "react-icons/md";
import { INotificationDStore } from "../notifications-panel";
import { NotificationCardWrapper } from "./styles";
import { useMemo } from "react";

import dstoreIcon from "../../../../../assets/icons/dstore-notification.svg";
import { useTranslation } from "react-i18next";

interface INotificationCard {
	notification: INotificationDStore;
	onDismiss: () => void;
}

export const NotificationCard: React.FC<INotificationCard> = (props) => {
	const { t: translate } = useTranslation();
	const hasLink = useMemo(
		() => props.notification.link,
		[props.notification.link]
	);

	return (
		<NotificationCardWrapper>
			<div className="header">
				<div className="from">
					<div className="icon">
						<img
							src={dstoreIcon}
							alt="ícone dstore"
						/>
					</div>
					<div className="name">
						{translate(
							`notifications.product_type.${props.notification.notification_origin_display.toLowerCase()}`
						)}
					</div>
				</div>

				<div className="dismiss">
					<button onClick={props.onDismiss}>
						<MdOutlineClose />
					</button>
				</div>
			</div>

			<div className="message">
				<div
					className="message"
					dangerouslySetInnerHTML={{
						__html: props.notification.body.body,
					}}
				></div>
				{hasLink && (
					<span>
						{" "}
						<a
							href={props.notification.link}
							target="_blank"
							onClick={props.onDismiss}
						>
							Ver mais.
						</a>
					</span>
				)}
			</div>
		</NotificationCardWrapper>
	);
};
